import { NgModule } from '@angular/core'
import { DisplayContractBulkActionStatePipe } from './display-contract-bulk-action-state.pipe'
import { DisplayContractBulkActionTypeNamePipe } from './display-contract-bulk-action-type-name.pipe'

@NgModule({
    declarations: [
        DisplayContractBulkActionStatePipe,
        DisplayContractBulkActionTypeNamePipe
    ],
    exports: [
        DisplayContractBulkActionStatePipe,
        DisplayContractBulkActionTypeNamePipe
    ]
})
export class BulkOperationPipesModule {}